const VIMEO_ORIGIN = "https://player.vimeo.com";

document.querySelectorAll(".hero_primary-layout").forEach((layout) => {
	// Zoekknop pas actief als er een filter gekozen is. Via JS uitgezet, zodat de knop zonder JS blijft werken.
	const submit = layout.querySelector("[data-hero-submit]");
	if (submit) {
		const selects = [...layout.querySelectorAll(".pk-select-input")];
		const sync = () => (submit.disabled = !selects.some((select) => select.value));
		selects.forEach((select) => select.addEventListener("change", sync));
		window.addEventListener("pageshow", sync);
		sync();
	}

	const video = layout.querySelector("[data-hero-video]");
	const iframe = layout.querySelector("[data-hero-vimeo]");
	const toggle = layout.querySelector("[data-hero-toggle]");
	if (!video && !iframe) return;

	const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	// Bij verminderde beweging blijft alleen de poster staan.
	if (reduceMotion) {
		video?.pause();
		video?.remove();
		iframe?.remove();
		toggle?.remove();
		return;
	}

	const setPlaying = (playing) => {
		layout.classList.toggle("is-paused", !playing);
		if (!toggle) return;
		toggle.setAttribute("aria-pressed", String(!playing));
		toggle.setAttribute("aria-label", toggle.dataset[playing ? "labelPause" : "labelPlay"]);
	};

	if (video) {
		video.addEventListener("playing", () => {
			layout.classList.add("is-playing");
			setPlaying(true);
		});
		video.addEventListener("pause", () => setPlaying(false));

		toggle?.addEventListener("click", () => (video.paused ? video.play() : video.pause()));

		// Faalt de laatste source, dan is er geen enkel bestand afspeelbaar (bijvoorbeeld als het Vimeo-plan is gestopt): terug naar de poster.
		[...video.querySelectorAll("source")].pop()?.addEventListener("error", () => {
			video.remove();
			toggle?.remove();
		});
		return;
	}

	// Vimeo: de iframe start pas na de load van de pagina, zodat de poster de LCP blijft.
	const send = (message) => iframe.contentWindow?.postMessage(JSON.stringify(message), VIMEO_ORIGIN);

	const start = () => {
		iframe.src = iframe.dataset.src;
	};
	document.readyState === "complete" ? start() : window.addEventListener("load", start, { once: true });

	iframe.addEventListener("load", () => {
		["play", "pause", "playProgress"].forEach((event) => send({ method: "addEventListener", value: event }));
	});

	window.addEventListener("message", (e) => {
		if (e.origin !== VIMEO_ORIGIN || e.source !== iframe.contentWindow) return;

		let data = e.data;
		if (typeof data === "string") {
			try { data = JSON.parse(data); } catch { return; }
		}

		if (data.event === "play" || data.event === "playProgress") {
			layout.classList.add("is-playing");
			setPlaying(true);
		} else if (data.event === "pause") {
			setPlaying(false);
		}
	});

	toggle?.addEventListener("click", () => send({ method: layout.classList.contains("is-paused") ? "play" : "pause" }));
});
